import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useCustomerQuery } from '../../../api/customers';
import { useBoolean } from 'usehooks-ts';
import { UpdatedView } from './UpdatedView';
import { UpdatePhoneForm } from './UpdatePhoneForm';

export function UpdatePhonePage() {
  const { t } = useTranslation();
  const customerQuery = useCustomerQuery();
  const identity = customerQuery.data?.identity;
  const changedFlag = useBoolean(false);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={identity?.hasPassword ? t('Change phone') : t('Set phone')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      {identity ? (
        changedFlag.value ? (
          <UpdatedView text={t('Phone successfully changed')} />
        ) : (
          <UpdatePhoneForm identity={identity} onComplete={changedFlag.setTrue} />
        )
      ) : null}
    </MainLayout>
  );
}
